import visitorApi from '@/api/visitor';

export default {
  async bindVisitor() {
    const ocsToken = localStorage.getItem('ocs_user_token');
    const customerWebsiteUserToken = localStorage.getItem('customer_website_user_token');
    if (!ocsToken || ocsToken.length < 1) {
      console.log('services.bindVisitor, skip: ocs_user_token missing');
      return null;
    }
    if (!customerWebsiteUserToken || customerWebsiteUserToken.length < 1) {
      console.log('services.bindVisitor, skip: customer_website_user_token missing');
      return null;
    }
    try {
      const response = await visitorApi.bindVisitor(customerWebsiteUserToken);
      console.log('services.bindVisitor, response:', response);
      if (response && response.status === 200) {
        return response.data;
      }
      throw new Error('bindVisitor, response:', response);
    } catch (error) {
      console.error('bindVisitor, error:', error);
      return null;
    }
  },
};
